m = require 'mithril'
CommonViews  = require './CommonViews'
ControlBlock = require './ControlBlock'

ImportDataPane = {
	controller: (args) ->
		ctrl = @
		ctrl.data = m.prop ''
		ctrl.errorMessage = m.prop null
		ctrl.onDataSupplied = () ->
			ctrl.errorMessage null
			try
				games = JSON.parse ctrl.data()
				args.onGamesSupplied games
			catch e
				ctrl.errorMessage "Sorry, there was a problem parsing the data:\n\n#{e}"
		@

	view: (ctrl, args) ->
		m '.importdatapane', [
			m 'h2', 'Import'
			m 'p', 'Paste some data from an export box on another device to import your games.'
			m 'textarea.importdatapane__data', {
				value: ctrl.data()
				onchange: m.withAttr 'value', ctrl.data
			}
			m 'p.importdatapane__error', ctrl.errorMessage() if ctrl.errorMessage()
			m ControlBlock, {content: [
				m 'button.importdatapane__button', {
					onclick: ctrl.onDataSupplied
				}, [
					CommonViews.icon CommonViews.icons.floppydisk, 'importdatapane__buttonicon'
					'Import supplied data'
				]
			]}
		]
}

module.exports = ImportDataPane